import React, { Component } from "react";

import Context from "../../../context/Context";
import LegendItems from "../common/LegendItems";
import * as component from "../../../components/util/component";

import { Panel } from "../../styles/Common/panel";
import {
  HeaderContainer,
  TitleRow,
  Title
} from "../../styles/Assets/assetStyles";

class LegendPanel extends Component {

  constructor(props) {
    super(props);
    this.state = component.newState({});
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  render() {
    const i18n = Context.instance.i18n;
    return (
      <Panel>
        <HeaderContainer>
          <TitleRow key="h">
            <Title>{i18n.spaceplanner.assets.legend.heading}</Title>
          </TitleRow>
        </HeaderContainer>

        <LegendItems />
      </Panel>
    );
  }
}

export default LegendPanel;